// NPM Imports
import React, { useState, useEffect } from "react";
import Modal from "react-responsive-modal";
import { Button, Input } from "../../../../revvComponents";

// Components Imports
import RevvField from "../MapperBlock/RevvField";
import SourceFieldsTransform from "./SourceFieldsTransform";

const FieldTransformerPopup = ({
  closeModal,
  saveTransformation,
  fieldMapping,
  fieldDef,
  sourceObjSchema,
  currentSelectedObject,
  dataSourceSelected,
  csvData,
}) => {
  const [schemaMapping, setSchemaMapping] = useState({});
  const [selectedFormat, setFormat] = useState({});

  useEffect(() => {
    const {
      mapping: { source_fields = [], operation, seperator } = {},
      isPrimaryKey,
    } = fieldMapping;
    const mapping = {
      source_fields,
    };
    if (source_fields.length > 1) {
      mapping.operation = operation || "concat";
      mapping.seperator = seperator || " ";
    }
    // check primary field
    mapping.isPrimaryKey = isPrimaryKey;
    setSchemaMapping(mapping);
  }, [fieldMapping]);

  useEffect(() => {
    const { mapping: { source_fields = [] } = {} } = fieldMapping;
    const getCurrentFormats = {};
    if (Array.isArray(source_fields)) {
      source_fields.forEach(sfield => {
        getCurrentFormats[sfield.name] = sfield.format || "COMMA";
      });
    }
    setFormat(getCurrentFormats);
  }, []);

  const _saveTransformationSettings = () => {
    const updatedSchema = {
      ...schemaMapping,
      source_fields: schemaMapping.source_fields.map(field => ({
        ...field,
        transform: field.transform.filter(
          tran => tran && tran.operation && tran.operation !== null,
        ),
        format: selectedFormat[field.name],
      })),
    };
    saveTransformation(updatedSchema, fieldMapping);
    closeModal();
  };

  const _updateConcatSeperator = event => {
    const updatedMapping = {
      ...schemaMapping,
      seperator: event.target.value,
    };
    setSchemaMapping(updatedMapping);
  };

  const _markPrimaryField = value => {
    const updatedMapping = {
      ...schemaMapping,
      isPrimaryKey: value,
    };
    setSchemaMapping(updatedMapping);
  };

  const _updateFieldTransform = (fieldIndex, updatedTransform) => {
    const updatedMapping = {
      ...schemaMapping,
    };
    updatedMapping.source_fields[fieldIndex] = {
      ...updatedMapping.source_fields[fieldIndex],
      transform: updatedTransform,
    };
    setSchemaMapping(updatedMapping);
  };

  const _selectFormat = (formatOption, sourceFieldName) => {
    setFormat(prevState => ({
      ...prevState,
      [sourceFieldName]: formatOption,
    }));
  };

  const { revvFieldID, revvSubField } = fieldMapping;
  const { source_fields: sourceFields = [] } = schemaMapping;
  let fieldList = [];
  if (dataSourceSelected === "csv" && Array.isArray(csvData.fields)) {
    fieldList = csvData.fields;
  } else {
    fieldList = sourceObjSchema[currentSelectedObject].All;
  }
  const sourceFieldsWithDefs = sourceFields.map(field => {
    const fieldDefs = fieldList.find(f => f.name === field.name);
    return fieldDefs;
  });
  let revvFieldTitle = "";
  if (revvFieldID && fieldDef) {
    revvFieldTitle = revvSubField
      ? `${fieldDef.label}.${revvSubField}`
      : fieldDef.label;
  }

  let isRevvFieldFreeTextClause = false;
  if (
    fieldDef &&
    fieldDef.type === "CLAUSE" &&
    fieldDef.meta &&
    fieldDef.meta.subtype === "free_text"
  ) {
    isRevvFieldFreeTextClause = true;
  }

  return (
    <Modal
      open
      onClose={closeModal}
      classNames={{ modal: "transform-settings-modal" }}
      closeOnOverlayClick
      center>
      <>
        <div className="transform-settings-container">
          <div className="modal-heading">
            Transformation settings for {`${revvFieldTitle}`}
          </div>
          <div className="transform-settings-body">
            <SourceFieldsTransform
              sourceFields={sourceFields}
              sourceFieldsWithDefs={sourceFieldsWithDefs}
              updateFieldTransform={_updateFieldTransform}
              selectFormat={_selectFormat}
              selectedFormat={selectedFormat}
              isRevvFieldFreeTextClause={isRevvFieldFreeTextClause}
            />

            {/* ------------ Revv form field section ------------ */}
            <div className="transform-lower-section">
              <div className="transform-settings-split">
                <div className="transform-settings-split-title">
                  Revv form field
                </div>
                <div className="transform-settings-split-body">
                  <RevvField title={revvFieldTitle} isRemoveAllowed={false} />
                </div>
              </div>
              <div className="transform-settings-mid-selector">
                <div className="transform-checkbox-confirm">
                  <Input
                    checked={schemaMapping.isPrimaryKey}
                    disabled={fieldDef.type === "TABLE_API"}
                    name="role"
                    onChange={() =>
                      _markPrimaryField(!schemaMapping.isPrimaryKey)
                    }
                    type="checkbox"
                    data-test="check-accept-document"
                    value={`Mark this as a primary field`}
                  />{" "}
                  {`Mark this as a primary field`}
                </div>
                {Array.isArray(sourceFields) && sourceFields.length > 1 && (
                  <>
                    <div className="transform-input-label">Concat </div>
                    <Input
                      className="transform-input-box"
                      data-test="transform-input-box"
                      type="text"
                      value={schemaMapping.seperator}
                      onChange={_updateConcatSeperator}
                      placeholder="Comma, Space, Hyphen"
                    />
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
        {/* Action */}
        <div className="transform-settings-footer">
          <Button
            data-test="transform-settings-save"
            className="transform-settings-footer-btn "
            onClick={_saveTransformationSettings}>
            Apply transformation
          </Button>
          <Button
            data-test="transform-settings-cancel"
            className="transform-settings-footer-btn btn btn-transparent"
            onClick={closeModal}>
            Cancel
          </Button>
        </div>
      </>
    </Modal>
  );
};

export default FieldTransformerPopup;
